import { Tile } from "./tile"

export class Market {
  tiles: Tile[]
  private maxSize: number

  constructor(maxSize: number) {
    this.tiles = []
    this.maxSize = maxSize
  }

  get size(): number {
    return this.tiles.length
  }

  get isEmpty(): boolean {
    return this.tiles.length === 0
  }

  /** Pick a tile from the market by index. Returns the tile or null if invalid. */
  pick(index: number): Tile | null {
    if (index < 0 || index >= this.tiles.length) return null
    return this.tiles.splice(index, 1)[0]
  }

  /** Refill market from deck up to maxSize. Returns number of tiles drawn. */
  refill(deck: Tile[]): number {
    let drawn = 0
    while (this.tiles.length < this.maxSize && deck.length > 0) {
      this.tiles.push(deck.pop()!)
      drawn++
    }
    return drawn
  }

  /** Get tiles for display (read-only copies not needed - caller should not mutate) */
  getTiles(): readonly Tile[] {
    return this.tiles
  }
}
